import getNodeName from "./getNodeName.js";
export default (function (element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
});